import { styled } from 'styled-components';

export const ButtonRow = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 16px;
`;
